import { ADMIN_ROUTES, MANAGER_ROUTES } from "./routes";
import type { BackofficeNavItem } from "./backofficeNav.types";

export const ADMIN_NAV_ITEMS: readonly BackofficeNavItem[] = [
  { to: `/${ADMIN_ROUTES.root}`, label: "Inicio", end: true },
  {
    to: `/${ADMIN_ROUTES.root}/${ADMIN_ROUTES.users}`,
    label: "Usuarios",
    permission: "users:manage",
  },
  {
    to: `/${ADMIN_ROUTES.root}/${ADMIN_ROUTES.castings}`,
    label: "Castings",
    permission: "castings:manage",
  },
  {
    to: `/${ADMIN_ROUTES.root}/${ADMIN_ROUTES.tenants}`,
    label: "Tenants",
    permission: "tenants:manage",
  },
  {
    to: `/${ADMIN_ROUTES.root}/${ADMIN_ROUTES.linkhub}/${MANAGER_ROUTES.linkGroups}`,
    label: "Central de links",
    permission: "linkhub:manage",
  },
  {
    to: `/${ADMIN_ROUTES.root}/${ADMIN_ROUTES.rooms}`,
    label: "Espacios físicos",
    permission: "rooms:manage",
  },
];
